import renumberWarmups from "../../../pages/survey/questions/renumber-statements";
import createWarmupElement from "../../../pages/survey/questions/create-statement-element";
import {swalFire, swalRemoveFire, swalWarningFire} from "../../../plugins/sweet-alert/sweet-alert-default";
import getMaxWarmupsCount from "../../../pages/survey/questions/get-max-warmups-count";
import {importWarmupsFromSheet, readWorksheetsFromXlsx} from "../import-statements";
import {showGenderColsIfBrandIsGenderSensitive} from "./show-gender-col";
import {clearPlaceholderIfBrandIsNotGenderSensitive} from "../statements/clear-placeholder";

export function attachWarmupStatements(context) {
    const $context = $(context);

    if (!$context.length) {
        return;
    }

    const warmupListPart = $context.find('.warmups-list-part').get(0);

    $(warmupListPart).on('change', '.edit-respondent input', function () {
        const isChecked = $(this).is(':checked');

        $(this).closest('.warmups-edit')
            .find('.warmups-item-edit-respondent')
            .toggleClass('hide', !isChecked);
    });

    $context.on('click', '[data-copy-warmup]', function (event) {
        event.preventDefault();

        $context.trigger('add-new-warmup', [$(this).data('name'),]);
    });

    $context.on('copy-warmup', function (event, el) {
        const $context = $(this);
        const $el = $(el);
        const name = $el.find('[data-name]').data('name');
        let $warmup = createWarmupElement($context.find('[data-warmup-template]'), name, '--warmup-ID--');

        if (!isWarmupsUnderLimit()) {
            swalWarningFire({
                title: 'Warmup limit',
                text: 'You have already used the maximum number of warmups in this part.',
            });
            $el.remove();

            return;
        }

        $warmup = showGenderColsIfBrandIsGenderSensitive($warmup, $context);

        $warmup.insertAfter($el);
        $el.remove();

        // renumber elements
        renumberWarmups($(warmupListPart));
    });

    $context.on('add-new-warmup', function (event, data = null) {
        const $context = $(this);

        // Return false if warmups count is over limit
        if (!isWarmupsUnderLimit()) {
            return;
        }

        let $warmup = createWarmupElement($context.find('[data-warmup-template]'), data, '--warmup-ID--');

        $warmup = clearPlaceholderIfBrandIsNotGenderSensitive($warmup, $context);

        // check if brand is gender sensitive
        $warmup = showGenderColsIfBrandIsGenderSensitive($warmup, $context);

        $warmup.appendTo(warmupListPart);

        // renumber elements
        renumberWarmups($(warmupListPart));
    });

    $context.on('remove-last-warmups', function (event, count) {
        const $context = $(this);
        const $warmupItems = $context.find('[data-warmups-list] [data-warmup-item]');
        $warmupItems.slice(-count).remove();
    });

    $context.on('establish-warmups', function (event, count) {
        const $context = $(this);
        const $warmupItems = $context.find('[data-warmups-list] [data-warmup-item]');
        const warmupsCount = $warmupItems.length;

        // Add new warmup inputs
        if (warmupsCount < count) {
            const addWarmupsCount = count - warmupsCount;
            for (let i = 1; i <= addWarmupsCount; i++) {
                $context.trigger('add-new-warmup');
            }
        }

        // Remove more warmups input than needed
        if (warmupsCount > count) {
            const removeWarmupsCount = count - warmupsCount;
            $context.trigger('remove-last-warmups', [removeWarmupsCount]);
        }
    });

    $context.on('remove-warmup', function (event, el) {
        swalRemoveFire({
            title: 'Remove',
            text: 'Do you really want to delete this warmup?',
        }).then((result) => {
            if (result.value !== true) {
                return;
            }

            $(el).closest('.warmups-mylist-item').slideUp().remove();

            // renumber elements
            renumberWarmups($(warmupListPart));
        });
    });

    $context.on('click', 'button[data-add-new-warmup]', function (event) {
        event.preventDefault();

        // Return false if warmups count is over limit
        if (!isWarmupsUnderLimit()) {
            swalWarningFire({
                title: 'Warmup limit',
                text: 'You have already used the maximum number of warmups in your survey.',
            });

            return;
        }

        $context.trigger('add-new-warmup');
    });

    $(warmupListPart).on('click', 'button.delete-warmup', function (event) {
        event.preventDefault();

        $context.trigger('remove-warmup', [$(this)]);
    });

    $context.on('change', '[data-import-warmups-from-file]', function (event) {
        event.preventDefault();

        readWorksheetsFromXlsx(this.files[0]).then(function (worksheets) {
            swalFire({
                title: 'Select worksheet',
                input: 'select',
                inputOptions: worksheets.map(sheet => sheet.name),
                customClass: {
                    input: 'form-control',
                    confirmButton: 'btn btn-label btn-min-width',
                    cancelButton: 'btn btn-label btn-min-width',
                },
                cancelButtonColor: '#74788d',
                showCancelButton: true,
            }).then(function (result) {
                if (result.isConfirmed) {
                    importWarmupsFromSheet(worksheets, result.value, $context);
                }
            });
        });
    });

    $context.on('toggle-warmups-brand-gender-sensitive', function () {
        const $context = $(this);
        const switchValue = checkBrandIsGenderSensitive($context);

        $context.find('[data-warmup-brand-gender-col]').each(function () {
            $(this).toggleClass('hide', !switchValue);
        });
    });

    $context.on('set-warmups-lock-icons-visibility', function (event, rotateWarmupsSwitch) {
        const $rotateWarmupsSwitch = $(rotateWarmupsSwitch);
        const rotateWarmupsSwitchVal = $rotateWarmupsSwitch.prop('checked');

        $(this).find('.blockWarmupSwitch').toggleClass('hide', !rotateWarmupsSwitchVal);
    });

    $context.find('[data-rotate-warmups-switch]').each(function () {
        $context.trigger('set-warmups-lock-icons-visibility', $(this));
    });

    function checkBrandIsGenderSensitive(context) {
        return $(context).find('.gender-switch input:checked').length > 0;
    }

    function isWarmupsUnderLimit() {
        const maxWarmupCount = getMaxWarmupsCount();
        const warmupCount = $(warmupListPart).find('.item-position').length;

        return warmupCount < maxWarmupCount;
    }
}
